import React from "react";
import { convertStringToArray } from "../../../Utils/utils";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useTableResponsive } from "../../../hooks/useTableResponsive";

const ReportsEnv = ({ data }) => {
  const { getText } = useLanguageTranslation();
  const convertedData = {
    ...data,
    field_document: convertStringToArray(data?.field_document),
  };

  useTableResponsive(data);

  return (
    <div className="wow fadeIn">
      <div className="title-sec">
        <h4 className="tit_3">{data?.title}</h4>
      </div>
      <div className="table-responsive">
        <table className="table table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>{getText("S.No.", "क्र. सं.")}</th>
              <th>{getText("Description", "विवरण")}</th>
              <th>{getText("Download", "डाउनलोड")}</th>
            </tr>
          </thead>
          <tbody>
            {convertedData.field_document.map((item, index) => (
              <tr>
                <td data-key={getText("S.No.", "क्र. सं.")}>{index + 1}</td>
                <td data-key={getText("Description", "विवरण")}>
                  {" "}
                  {item.title}
                </td>
                <td data-key={getText("Download", "डाउनलोड")}>
                  <a
                    href={`${process.env.REACT_APP_IMAGE_URL}/${item?.file_path}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="pdf-icon">
                      <img
                        src={`${process.env.REACT_APP_IMAGE_URL_FRONTEND}/images/pdf-icon.png`}
                        alt="pdf-icon"
                        className="mr-2"
                      />
                    </div>
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportsEnv;
